import { SUPPORT_EMAIL } from "./shared/constants";


const MAILTO_BODY = `body=%0A%0A---%20please%20write%20above%20this%20line%20---%0AinstanceId%3A%20`
const DEFAULT_SUBJECT = 'subject=Customer%20Feedback';
const SUBJECTS: Record<string, string> = {
    offSiteCollection: 'subject=Customer%20Feedback%20-%20Enable%20Off%20Site%20Collection',
    notifications: 'subject=Customer%20Feedback%20-%20Enable%20Notifications',
}
const MAILTO = `mailto:${SUPPORT_EMAIL}`;

export const getMailto = (instanceId: string, type: string = '') => {
    const subject = SUBJECTS[type] || DEFAULT_SUBJECT;

    return `${MAILTO}?${subject}&${MAILTO_BODY}${instanceId}%0A`;
}